import { Pagination, PaginationMessage } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ChatbotState = {
  dataHistortChatbot: historyChatbotType[];
  dataMessageChatbot: historyMessageChatbotType[];
  pagination: PaginationAPI;
  paginationMessage: PaginationAPI;
  totalElements?: number;
  loading: boolean;
};

export const chatbotInitialState: ChatbotState = {
  dataHistortChatbot: [],
  dataMessageChatbot: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  paginationMessage: {
    Page: PaginationMessage.Page,
    totalPages: 0,
    totalElements: 0,
    Size: PaginationMessage.Size,
  },
  loading: false,
};

const slice = createSlice({
  name: 'chatbot',
  initialState: chatbotInitialState,
  reducers: {
    setListHistoryChatAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: historyChatbotType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataHistortChatbot = payload.data;

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
    setListMessageChatAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: historyMessageChatbotType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataMessageChatbot = payload.data;

      state.paginationMessage = payload.pagination || state.paginationMessage;
      state.totalElements = payload.pagination?.totalElements;
    },
    deleteHistoryChatAction(state, { payload }: PayloadAction<string>) {
      state.dataHistortChatbot = state.dataHistortChatbot.filter(
        (item) => !payload.includes(item.id!),
      );
    },
  },
});

export const { setListHistoryChatAction, setListMessageChatAction, deleteHistoryChatAction } =
  slice.actions;
export default slice.reducer;
